import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Tab } from '../../resources/types/TabsTypes';

const getToken = () => {
  const storeUserInfo = localStorage.getItem('STORE_USER_INFO');
  if (storeUserInfo) {
    const parsed = JSON.parse(storeUserInfo);
    return parsed.token;
  }
  return null;
};

export const tabsApi = createApi({
  reducerPath: 'tabsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}/api`,
    prepareHeaders: (headers) => {
      const token = getToken();
      if (token) {
        headers.set('x-access-token', token);
      }
      return headers;
    }
  }),
  tagTypes: ['Tab'],
  endpoints: (builder) => ({
    getTabs: builder.query<{ tabs: Tab[] }, void>({
      query: () => '/tabs',
      providesTags: ['Tab']
    })
  })
});

export const { useGetTabsQuery } = tabsApi;
